// @flow

import React, { useState } from 'react'
import { useQuery, useMutation } from "@apollo/client"
import { v4 } from "uuid"
import { withTranslation } from 'react-i18next'
import { withRouter } from "react-router"



import {
  Icon,
  Dimmer,
  Button,
  Card,
  Table
} from "tabler-react";
import { toast } from 'react-toastify'

import ContentCard from "../../general/ContentCard"
import OrganizationShiftsBase from './OrganizationShiftsBase'

import { GET_SHIFTS_QUERY, ARCHIVE_SHIFT } from "./queries"


function OrganizationShifts({t, history}) {
  let [archived, setArchived] = useState(false)
  const cardTitle = t('organization.shifts.title')
  const { loading, error, data, refetch, fetchMore } = useQuery(GET_SHIFTS_QUERY, {
    variables: { archived: archived }
  })
  const [ archiveShift ] = useMutation(ARCHIVE_SHIFT)

  const headerOptions = <Card.Options>
    <Button color={(!archived) ? 'primary': 'secondary'}  
            size="sm"
            onClick={() => {setArchived(false); refetch({archived: false});}}>
      {t('general.current')}
    </Button>
    <Button color={(archived) ? 'primary': 'secondary'} 
            size="sm" 
            className="ml-2" 
            onClick={() => {setArchived(true); refetch({archived: true});}}>
      {t('general.archive')}
    </Button>
  </Card.Options>

  if (loading) return (
    <OrganizationShiftsBase>
      <ContentCard cardTitle={cardTitle}>
        <Dimmer active={true}
                loader={true}>
        </Dimmer>
      </ContentCard>
    </OrganizationShiftsBase>
  )

  if (error) return (
    <OrganizationShiftsBase>
      <ContentCard cardTitle={cardTitle}>
        <p>{t('organization.shifts.error_loading')}</p>
      </ContentCard>
    </OrganizationShiftsBase>
  )

  let shifts = data.organizationShifts

  // Empty list
  if (!shifts.edges.length) { return (
    <OrganizationShiftsBase>
      <ContentCard cardTitle={t('organization.shifts.title')}
                    headerContent={headerOptions}>
        <p>
          {(!archived) ? t('organization.shifts.empty_list') : t("organization.shifts.empty_archive")}
        </p>
      </ContentCard>
    </OrganizationShiftsBase>
  )}


  return (
    <OrganizationShiftsBase>
      <ContentCard 
        cardTitle={cardTitle}
        headerContent={headerOptions}
        hasCardBody={false}
        pageInfo={shifts.pageInfo}
        onLoadMore={() => {
        fetchMore({
          variables: {
            after: shifts.pageInfo.endCursor
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const newEdges = fetchMoreResult.organizationShifts.edges
            const pageInfo = fetchMoreResult.organizationShifts.pageInfo

            return newEdges.length
              ? {
                  // Put the new shifts at the end of the list and update `pageInfo`
                  // so we have the new `endCursor` and `hasNextPage` values
                  organizationShifts: {
                    __typename: previousResult.organizationShifts.__typename,
                    edges: [ ...previousResult.organizationShifts.edges, ...newEdges ],
                    pageInfo
                  }
                }
              : previousResult
          }
        })
      }} >
        <Table cards>
          <Table.Header>
            <Table.Row key={v4()}>
              <Table.ColHeader>{t('general.name')}</Table.ColHeader>
              <Table.ColHeader></Table.ColHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
              {shifts.edges.map(({ node }) => (
                <Table.Row key={v4()}>
                  <Table.Col key={v4()}>
                    {node.name}
                  </Table.Col>
                  <Table.Col className="text-right" key={v4()}>
                    {(node.archived) ? 
                      <span className='text-muted'>{t('general.unarchive_to_edit')}</span> :
                      <Button className='btn-sm' 
                              onClick={() => history.push("/organization/shifts/edit/" + node.id)}
                              color="secondary">
                        {t('general.edit')}
                      </Button>
                    }
                    <button className="icon btn btn-link btn-sm" 
                        title={t('general.archive')} 
                        href=""
                        onClick={() => {
                          console.log("clicked archived")
                          let id = node.id
                          archiveShift({ variables: {
                            input: {
                            id,
                            archived: !archived
                            }
                    }, refetchQueries: [
                        {query: GET_SHIFTS_QUERY, variables: {"archived": archived }}
                    ]}).then(({ data }) => {
                      console.log('got data', data);
                      toast.success(
                        (archived) ? t('general.unarchived'): t('general.archived'), {
                          position: toast.POSITION.BOTTOM_RIGHT
                        })
                    }).catch((error) => {
                      toast.error((t('general.toast_server_error')) +  error, {
                          position: toast.POSITION.BOTTOM_RIGHT
                        })
                      console.log('there was an error sending the query', error);
                    })
                    }}>
                      <Icon prefix="fe" name="inbox" />
                    </button>
                  </Table.Col>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </ContentCard>
    </OrganizationShiftsBase>
  )
}



export default withTranslation()(withRouter(OrganizationShifts))